import React from "react";

const Home = () => {
  return (
    <>
      <div className="hero border-1 pb-3">
        <div className="card bg-dark text-white border-0 mx-3">
          <img
            className="card-img img-fluid"
            src="./assets/banner-top-test.jpg"
            alt="Card"
            style={{ maxHeight: "70vh", width: "100%", objectFit: "cover" }}
          />
          <div className="card-img-overlay d-flex align-items-center">
            <div className="container">
              <h5 className="card-title fs-1 text fw-lighter">MLUs</h5>
              <p className="card-text fs-5 d-none d-sm-block ">
                Lorem ipsum, dolor sit amet consectetur adipisicing elit. Est
                rem, magnam, quia animi fugit natus, exercitationem quis fugiat
                quam a nemo fuga. Et consectetur, vitae perferendis ipsa sequi
                quaerat quia accusamus laudantium porro tempore voluptatibus eum
                magnam fugiat aspernatur ipsam, unde enim dolor explicabo
                blanditiis maiores harum totam, molestias rerum beatae!
                Voluptates quis saepe dicta tempore similique ut unde dolores
                molestiae dolorem, ipsa harum rerum in eum cum dolore voluptatem
                consectetur amet. Asperiores earum similique maxime quod soluta
                in mollitia.
              </p>
              <p className="card-text fs-5 d-none d-sm-block ">
                MRUs are currently in development.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;

// ChipsetRC currently provides a range of lighting control units
//                 for RC models. There are specialised units for police vehicles
//                 as well as trucks and boats.
